<template>
  <v-card class="px-4 py-8 d-flex flex-column text-center justify-center" style="height:100%">
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="back" color="back" text @click="closeModal()">
        <v-icon color="#ba0009">mdi-close</v-icon>
      </v-btn>
    </v-card-actions>
    <h3 style="font-family:mplus-2c-light;">じっくり話して、しっかり決める。</h3>
    <v-img src="../../assets/png/Liqlid_icon_logo.png" width="60%" class="my-6 mx-auto"></v-img>
    <!-- officerShownの時、職員番号でログイン というボタンを表示。また、これはchangeViewではなく、/officers-login というページへ遷移する -->
    <v-btn
      v-if="officerShown"
      color="primary"
      class="white--text mx-auto rounded-pill mb-4"
      @click="changeView('officer')"
      width="70%"
    >
      職員番号で続ける
    </v-btn>
    <v-btn
      color="primary"
      class="white--text mx-auto rounded-pill mb-4"
      @click="changeView('signin')"
      width="70%"
    >
      {{officerShown?"メールで":""}}ログイン
    </v-btn>
    <line-button v-if="authConfig.line" class="mb-4"></line-button>
    <slp-button v-if="authConfig.slp" class="mb-4"></slp-button>
    <router-link to="/signup" class="white--text" style="text-decoration: none;">
      <v-btn
        class="white--text mx-auto rounded-pill"
        width="70%"
        color="#707070"
      >
        はじめて利用する
      </v-btn>
    </router-link>
  </v-card>
</template>

<script>
import lineButton from './parts/lineButton.vue'
import slpButton from './parts/slpButton.vue'
export default {
  components: { lineButton, slpButton },
  data () {
    return {
      authConfig: JSON.parse(process.env.VUE_APP_AUTH || '{}'),  // 例→ {line:1,slp:0,officer:1}
      officerShown: false
    }
  },
  mounted () {
    if (localStorage.getItem('enableOfficerButton') === 'true' && this.authConfig.officer) {
      this.officerShown = true
    }
  },
  methods: {
    changeView (view) {
      if (view === 'officer') {
        this.$router.push('/officers-login')
        return
      }
      this.$emit('changeView', view)
    },
    closeModal(){
      this.$emit('closeModal')
    },
  }
}
</script>